'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.title15 = exports.title14 = exports.link = exports.rectangularButtonText = exports.ctaButtonText = exports.beginButtonText = exports.title11 = exports.title10 = exports.title7 = exports.title6 = exports.title2 = exports.utility5 = exports.utility4 = exports.utility3 = exports.utility2 = exports.utility1 = exports.p4 = exports.p3 = exports.p2 = exports.p1 = exports.h6 = exports.h5 = exports.h4 = exports.h3 = exports.h2 = exports.h1 = exports.labelBoldS = exports.labelRegularS = exports.labelBoldM = exports.uiBoldS = exports.uiBoldM = exports.uiBoldL = exports.uiRegularS = exports.uiRegularM = exports.uiRegularL = exports.titleXS = exports.titleS = exports.titleM = exports.titleL = exports.display1 = exports.uppercase = exports.loosestText = exports.looseText = exports.spaceyText = exports.blackitalic = exports.black = exports.bolditalic = exports.bold = exports.mediumitalic = exports.medium = exports.lightitalic = exports.light = exports.thinitalic = exports.thin = exports.regularitalic = exports.regular = exports.fontFamily = undefined;

var _css2;

exports.createType = createType;
exports.createTypeSet = createTypeSet;

var _glamor = require('@headspace/glamor');

var _objectAssign = require('object-assign');

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _breakpoints = require('./breakpoints');

var _breakpoints2 = _interopRequireDefault(_breakpoints);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}
/**
 * fonts
 * -----
 **/
// font families


var fontFamily = exports.fontFamily = (0, _glamor.css)({
  fontFamily: 'Apercu, sans-serif',
  textRendering: 'optimizeLegibility',
  WebkitFontSmoothing: 'antialiased',
  MozOsxFontSmoothing: 'grayscale',
  WebkitOverflowScrolling: 'touch'
});
var regular = exports.regular = (0, _glamor.css)(fontFamily, {
  fontWeight: 400,
  fontStyle: 'normal'
});
var regularitalic = exports.regularitalic = (0, _glamor.css)(fontFamily, {
  fontWeight: 400,
  fontStyle: 'italic'
});
var thin = exports.thin = (0, _glamor.css)(fontFamily, {
  fontWeight: 100,
  fontStyle: 'normal'
});
var thinitalic = exports.thinitalic = (0, _glamor.css)(fontFamily, {
  fontWeight: 100,
  fontStyle: 'italic'
});
var light = exports.light = (0, _glamor.css)(fontFamily, {
  fontWeight: 100,
  fontStyle: 'normal'
});
var lightitalic = exports.lightitalic = (0, _glamor.css)(fontFamily, {
  fontWeight: 300,
  fontStyle: 'italic'
});
var medium = exports.medium = (0, _glamor.css)(fontFamily, {
  fontWeight: 500,
  fontStyle: 'normal'
});
var mediumitalic = exports.mediumitalic = (0, _glamor.css)(fontFamily, {
  fontWeight: 500,
  fontStyle: 'italic'
});
var bold = exports.bold = (0, _glamor.css)(fontFamily, {
  fontWeight: 700,
  fontStyle: 'normal'
});
var bolditalic = exports.bolditalic = (0, _glamor.css)(fontFamily, {
  fontWeight: 700,
  fontStyle: 'italic'
});
var black = exports.black = (0, _glamor.css)(fontFamily, {
  fontWeight: 900,
  fontStyle: 'normal'
});
var blackitalic = exports.blackitalic = (0, _glamor.css)(fontFamily, {
  fontWeight: 900,
  fontStyle: 'italic'
});

function createType(fontSize, lineHeight) {
  var extra = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return (0, _objectAssign2.default)({
    fontSize: fontSize,
    lineHeight: lineHeight + 'px'
  }, extra);
}

function createTypeSet(base, fontSize, lineHeight) {
  var sets = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return (0, _glamor.css)(base, createType(fontSize, lineHeight, Object.keys(sets).reduce(function (accum, breakpoint) {
    var set = sets[breakpoint];
    accum['@media(min-width: ' + _breakpoints2.default[breakpoint] + 'px)'] = createType.apply(undefined, _toConsumableArray(set));
    return accum;
  }, {})));
} // letter spacing


var spaceyText = exports.spaceyText = (0, _glamor.css)({
  letterSpacing: '2.5px'
});
var looseText = exports.looseText = (0, _glamor.css)(_defineProperty({
  letterSpacing: '3px'
}, '@media(min-width: ' + _breakpoints2.default.xl + 'px)', {
  letterSpacing: '3.5px'
}));
var loosestText = exports.loosestText = (0, _glamor.css)((_css2 = {
  letterSpacing: '3px'
}, _defineProperty(_css2, '@media(min-width: ' + _breakpoints2.default.m + 'px)', {
  letterSpacing: '6px'
}), _defineProperty(_css2, '@media(min-width: ' + _breakpoints2.default.xl + 'px)', {
  letterSpacing: '8px'
}), _css2)); // transforms

var uppercase = exports.uppercase = (0, _glamor.css)({
  textTransform: 'uppercase'
}); // typesets
// b2b/user-cms typesets

var display1 = exports.display1 = createTypeSet(bold, 44, 52, {});
var titleL = exports.titleL = createTypeSet(bold, 36, 44, {});
var titleM = exports.titleM = createTypeSet(bold, 28, 36, {});
var titleS = exports.titleS = createTypeSet(bold, 24, 32, {});
var titleXS = exports.titleXS = createTypeSet(bold, 20, 28, {});
var uiRegularL = exports.uiRegularL = createTypeSet(regular, 16, 24, {});
var uiRegularM = exports.uiRegularM = createTypeSet(regular, 14, 20, {});
var uiRegularS = exports.uiRegularS = createTypeSet(regular, 12, 16, {});
var uiBoldL = exports.uiBoldL = createTypeSet(bold, 16, 24, {});
var uiBoldM = exports.uiBoldM = createTypeSet(bold, 14, 20, {});
var uiBoldS = exports.uiBoldS = createTypeSet(bold, 12, 16, {});
var labelBoldM = exports.labelBoldM = createTypeSet((0, _glamor.css)(bold, spaceyText, uppercase), 14, 20, {});
var labelRegularS = exports.labelRegularS = createTypeSet((0, _glamor.css)(regular, spaceyText, uppercase), 12, 16, {});
var labelBoldS = exports.labelBoldS = createTypeSet((0, _glamor.css)(bold, spaceyText, uppercase), 12, 16, {}); // webapp/website/content-cms typesets

var h1 = exports.h1 = createTypeSet(bold, 40, 48, {
  l: [88, 96]
});
var h2 = exports.h2 = createTypeSet(bold, 32, 40, {
  l: [72, 80]
});
var h3 = exports.h3 = createTypeSet(bold, 24, 32, {
  l: [56, 64]
});
var h4 = exports.h4 = createTypeSet(bold, 24, 32, {
  l: [40, 48]
});
var h5 = exports.h5 = createTypeSet(bold, 20, 32, {
  l: [32, 40]
});
var h6 = exports.h6 = createTypeSet(bold, 16, 24, {
  l: [24, 32]
});
var p1 = exports.p1 = createTypeSet(regular, 24, 40, {
  l: [48, 64]
});
var p2 = exports.p2 = createTypeSet(regular, 20, 32, {
  l: [32, 48]
});
var p3 = exports.p3 = createTypeSet(regular, 16, 24, {
  l: [24, 40]
});
var p4 = exports.p4 = createTypeSet(regular, 14, 20, {
  l: [16, 20]
});
var utility1 = exports.utility1 = createTypeSet((0, _glamor.css)(regular, spaceyText), 16, 20, {
  l: [24, 32]
});
var utility2 = exports.utility2 = createTypeSet((0, _glamor.css)(bold, spaceyText), 14, 16, {
  l: [16, 20]
});
var utility3 = exports.utility3 = createTypeSet((0, _glamor.css)(bold, spaceyText), 12, 16, {
  l: [14, 16]
});
var utility4 = exports.utility4 = createTypeSet((0, _glamor.css)(regular, spaceyText), 12, 16, {
  l: [14, 16]
});
var utility5 = exports.utility5 = createTypeSet((0, _glamor.css)(regular, spaceyText), 12, 16, {
  l: [12, 16]
}); // old deprecated styles
// you should not use any of these for new designs
// TODO: survey webapp to see if any of these are used

var title2 = exports.title2 = createTypeSet(bold, 44, 48, {
  m: [56, 64],
  xl: [72, 80]
});
var title6 = exports.title6 = createTypeSet(bold, 24, 32, {});
var title7 = exports.title7 = createTypeSet(regular, 24, 32, {
  m: [24, 40]
});
var title10 = exports.title10 = createTypeSet((0, _glamor.css)(bold, looseText, uppercase), 16, 25, {
  m: [20, 29]
});
var title11 = exports.title11 = createTypeSet(regular, 12, 20, {
  m: [20, 28]
});
var beginButtonText = exports.beginButtonText = createTypeSet((0, _glamor.css)(bold, looseText, uppercase), 14, 16, {
  m: [20, 28]
});
var ctaButtonText = exports.ctaButtonText = createTypeSet((0, _glamor.css)(bold, looseText, uppercase), 16, 24, {
  m: [20, 28]
});
var rectangularButtonText = exports.rectangularButtonText = createTypeSet((0, _glamor.css)(bold, spaceyText, uppercase), 14, 16, {
  xxl: [24, 32],
  m: [16, 20]
});
var link = exports.link = createTypeSet((0, _glamor.css)(regular), 12, 20, {});
var title14 = exports.title14 = createTypeSet(regular, 24, 36, {
  m: [40, 56]
});
var title15 = exports.title15 = createTypeSet((0, _glamor.css)(bold, spaceyText, uppercase), 14, 16, {
  m: [16, 20]
});